import { Link } from 'react-router-dom'
import { signOut } from 'firebase/auth'
import { auth } from '../firebase'
import { useNavigate } from 'react-router-dom'

function SignupBar() {
  const navigate = useNavigate()
  const user = auth.currentUser

  // Log out function
  function logOut() {
    signOut(auth)
    navigate('/')
  }

  return (
    <div className="mb-4 flex justify-center md:justify-end">
      {/* Log in button */}
      {!user && (
        <Link
          to="/login"
          className="btn border-2 border-primary text-primary transition duration-500 ease-out hover:bg-primary hover:text-white"
        >
          Log in
        </Link>
      )}
      {/* Log out button */}
      {user && (
        <button
          className="btn border-2 border-primary text-primary transition duration-500 ease-out hover:bg-primary hover:text-white"
          onClick={() => {
            logOut()
          }}
        >
          Sign Out
        </button>
      )}
      {/* Sign up */}
      {!user && (
        <Link
          to="/signup"
          className="btn ml-2 border-2 border-primary text-primary transition duration-500 ease-out hover:bg-primary hover:text-white"
        >
          Sign up
        </Link>
      )}
    </div>
  )
}

export default SignupBar
